var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "statistics_page_wrapper" } },
    [
      _c("div", { staticClass: "bb-mobile-header" }, [
        _c("div", { staticClass: "bb-mobile-header-left" }, [
          _c(
            "button",
            {
              staticClass: "mobile-sidebar-btn",
              on: {
                click: function ($event) {
                  return _vm.openMobileAside()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-menu",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("line", {
                    attrs: { x1: "3", y1: "12", x2: "21", y2: "12" },
                  }),
                  _c("line", {
                    attrs: { x1: "3", y1: "6", x2: "21", y2: "6" },
                  }),
                  _c("line", {
                    attrs: { x1: "3", y1: "18", x2: "21", y2: "18" },
                  }),
                ]
              ),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "mobile-period-filter-toggle-btn",
              on: {
                click: function ($event) {
                  return _vm.openMobilePeriodFilter()
                },
              },
            },
            [
              _vm.period.day
                ? _c("span", [
                    _vm._v(_vm._s(_vm.period.day + " " + _vm.monthName + " ")),
                  ])
                : _vm._e(),
              !_vm.period.day && _vm.period.month
                ? _c("span", [_vm._v(_vm._s(_vm.monthName + " "))])
                : _vm._e(),
              !_vm.period.day && !_vm.period.month
                ? _c("span", [_vm._v(_vm._s(_vm.period.year))])
                : _vm._e(),
              _vm.period.day || _vm.period.month
                ? _c("small", [_vm._v(_vm._s(_vm.period.year))])
                : _vm._e(),
              _c("i", { staticClass: "la la-angle-down" }),
            ]
          ),
        ]),
        _c("div", { staticClass: "bb-mobile-header-right" }, [
          _c(
            "button",
            {
              staticClass: "ml-7",
              on: {
                click: function ($event) {
                  return _vm.openMobilePlacesFilter()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "22",
                    height: "22",
                    viewBox: "0 0 22 22",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M18.0642 0H3.93577C1.76559 0 0 1.76559 0 3.93577V18.0643C0 20.2344 1.76559 22 3.93577 22H18.0643C20.2344 22 22 20.2344 22 18.0642V3.93577C22 1.76559 20.2344 0 18.0642 0ZM20.7109 18.0642C20.7109 19.5236 19.5236 20.7109 18.0642 20.7109H3.93577C2.47638 20.7109 1.28906 19.5236 1.28906 18.0642V3.93577C1.28906 2.47638 2.47638 1.28906 3.93577 1.28906H18.0643C19.5236 1.28906 20.7109 2.47638 20.7109 3.93577V18.0642Z",
                      fill: "#253342",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M18.5942 4.83262H8.77756C8.50767 4.03104 7.74949 3.4519 6.85806 3.4519C5.96663 3.4519 5.20845 4.03104 4.93856 4.83262H3.40625C3.0503 4.83262 2.76172 5.1212 2.76172 5.47715C2.76172 5.8331 3.0503 6.12168 3.40625 6.12168H4.9386C5.20849 6.92326 5.96667 7.5024 6.8581 7.5024C7.74953 7.5024 8.50772 6.92326 8.7776 6.12168H18.5943C18.9502 6.12168 19.2388 5.8331 19.2388 5.47715C19.2388 5.1212 18.9502 4.83262 18.5942 4.83262ZM6.85806 6.21333C6.45213 6.21333 6.12188 5.88308 6.12188 5.47715C6.12188 5.07122 6.45213 4.74097 6.85806 4.74097C7.26399 4.74097 7.59424 5.07122 7.59424 5.47715C7.59424 5.88308 7.26399 6.21333 6.85806 6.21333Z",
                      fill: "#253342",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M18.5942 10.3556H17.0619C16.792 9.55399 16.0338 8.97485 15.1424 8.97485C14.251 8.97485 13.4928 9.55399 13.2229 10.3556H3.40625C3.0503 10.3556 2.76172 10.6441 2.76172 11.0001C2.76172 11.3561 3.0503 11.6446 3.40625 11.6446H13.2229C13.4928 12.4462 14.251 13.0253 15.1424 13.0253C16.0338 13.0253 16.792 12.4462 17.0619 11.6446H18.5943C18.9502 11.6446 19.2388 11.3561 19.2388 11.0001C19.2388 10.6441 18.9502 10.3556 18.5942 10.3556ZM15.1424 11.7363C14.7365 11.7363 14.4063 11.406 14.4063 11.0001C14.4063 10.5942 14.7365 10.2639 15.1424 10.2639C15.5484 10.2639 15.8786 10.5942 15.8786 11.0001C15.8786 11.406 15.5484 11.7363 15.1424 11.7363Z",
                      fill: "#253342",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M18.5942 15.8784H11.539C11.2691 15.0768 10.511 14.4977 9.61953 14.4977C8.7281 14.4977 7.96992 15.0768 7.70003 15.8784H3.40625C3.0503 15.8784 2.76172 16.167 2.76172 16.5229C2.76172 16.8789 3.0503 17.1675 3.40625 17.1675H7.70003C7.96992 17.969 8.7281 18.5482 9.61953 18.5482C10.511 18.5482 11.2691 17.969 11.539 17.1675H18.5943C18.9502 17.1675 19.2388 16.8789 19.2388 16.5229C19.2388 16.167 18.9502 15.8784 18.5942 15.8784ZM9.61953 17.2592C9.21361 17.2592 8.88335 16.9289 8.88335 16.523C8.88335 16.117 9.21361 15.7868 9.61953 15.7868C10.0255 15.7868 10.3557 16.117 10.3557 16.5229C10.3557 16.9289 10.0255 17.2592 9.61953 17.2592Z",
                      fill: "#253342",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between align-items-center mb-5 filters-container",
        },
        [
          _c("PlaceFilter", {
            on: {
              placeChanged: function ($event) {
                return _vm.placeChanged($event)
              },
            },
          }),
          _c("PeriodFilter", {
            on: {
              periodChanged: function ($event) {
                return _vm.periodChanged($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between align-items-stretch mb-5 total-cards-container",
        },
        [
          _c("div", { staticClass: "bb-card total-statistic-card" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("statistics.totalSalesLabel")))]),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-baseline",
              },
              [
                _c("span", { staticClass: "total-statistic-count" }, [
                  _vm._v(_vm._s(_vm.currentStatistic.totalSales)),
                  _c("span", { staticClass: "total-statistic-currency" }, [
                    _vm._v(_vm._s(_vm.$t("statistics.currencyLabel"))),
                  ]),
                ]),
                _vm.changeDisplay("totalSales")
                  ? _c(
                      "div",
                      {
                        staticClass: "total-statistic-precentage",
                        class: _vm.changeDisplay("totalSales").class,
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.changeDisplay("totalSales").label)),
                        ]),
                        _c(
                          "svg",
                          {
                            staticClass: "precentage-arrow",
                            class: _vm.changeDisplay("totalSales").arrowClass,
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("line", {
                              attrs: { x1: "12", y1: "19", x2: "12", y2: "5" },
                            }),
                            _c("polyline", {
                              attrs: {
                                points:
                                  _vm.changeDisplay("totalSales").arrowPoints,
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _c("div", { staticClass: "bb-card total-statistic-card" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("statistics.totalAppointmentsLabel"))),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-baseline",
              },
              [
                _c("span", { staticClass: "total-statistic-count" }, [
                  _vm._v(_vm._s(_vm.currentStatistic.totalAppointments)),
                ]),
                _vm.changeDisplay("totalAppointments")
                  ? _c(
                      "div",
                      {
                        staticClass: "total-statistic-precentage",
                        class: _vm.changeDisplay("totalAppointments").class,
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.changeDisplay("totalAppointments").label)
                          ),
                        ]),
                        _c(
                          "svg",
                          {
                            staticClass: "precentage-arrow",
                            class:
                              _vm.changeDisplay("totalAppointments").arrowClass,
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("line", {
                              attrs: { x1: "12", y1: "19", x2: "12", y2: "5" },
                            }),
                            _c("polyline", {
                              attrs: {
                                points:
                                  _vm.changeDisplay("totalAppointments")
                                    .arrowPoints,
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _c("div", { staticClass: "bb-card total-statistic-card" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("statistics.completedAppointmentsLabel"))),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-baseline",
              },
              [
                _c("span", { staticClass: "total-statistic-count" }, [
                  _vm._v(_vm._s(_vm.currentStatistic.completedAppointments)),
                ]),
                _vm.changeDisplay("completedAppointments")
                  ? _c(
                      "div",
                      {
                        staticClass: "total-statistic-precentage",
                        class: _vm.changeDisplay("completedAppointments").class,
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.changeDisplay("completedAppointments").label
                            )
                          ),
                        ]),
                        _c(
                          "svg",
                          {
                            staticClass: "precentage-arrow",
                            class: _vm.changeDisplay("completedAppointments")
                              .arrowClass,
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("line", {
                              attrs: { x1: "12", y1: "19", x2: "12", y2: "5" },
                            }),
                            _c("polyline", {
                              attrs: {
                                points: _vm.changeDisplay(
                                  "completedAppointments"
                                ).arrowPoints,
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
          _c("div", { staticClass: "bb-card total-statistic-card" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("statistics.canceledAppointmentsLabel"))),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-baseline",
              },
              [
                _c("span", { staticClass: "total-statistic-count" }, [
                  _vm._v(_vm._s(_vm.currentStatistic.canceledAppointments)),
                ]),
                _vm.changeDisplay("canceledAppointments")
                  ? _c(
                      "div",
                      {
                        staticClass: "total-statistic-precentage",
                        class: _vm.changeDisplay("canceledAppointments").class,
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.changeDisplay("canceledAppointments").label
                            )
                          ),
                        ]),
                        _c(
                          "svg",
                          {
                            staticClass: "precentage-arrow",
                            class: _vm.changeDisplay("canceledAppointments")
                              .arrowClass,
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("line", {
                              attrs: { x1: "12", y1: "19", x2: "12", y2: "5" },
                            }),
                            _c("polyline", {
                              attrs: {
                                points: _vm.changeDisplay(
                                  "canceledAppointments"
                                ).arrowPoints,
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "d-flex justify-content-between sales-container" },
        [
          _c(
            "div",
            {
              staticClass: "bb-card statistic-card mr-5",
              staticStyle: { flex: "1.5" },
            },
            [
              _c("h4", [_vm._v(_vm._s(_vm.$t("statistics.staffSalesLabel")))]),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center flex-wrap",
                },
                [
                  _c("StaffChart", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.currentStatistic &&
                          _vm.currentStatistic.staffSales,
                        expression:
                          "currentStatistic && currentStatistic.staffSales",
                      },
                    ],
                    ref: "staffChart",
                    staticClass: "staff-chart-container",
                    attrs: { chartData: _vm.staffChartData },
                  }),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.currentStatistic ||
                            !_vm.currentStatistic.staffSales,
                          expression:
                            "\n                        !currentStatistic || !currentStatistic.staffSales\n                    ",
                        },
                      ],
                      staticClass: "text-main",
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("statistics.noDataLabel")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "staff-statistic-list" },
                    _vm._l(
                      _vm.currentStatistic.staffSales,
                      function (staffMember, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass:
                              "d-flex justify-content-between align-items-center mt-2 mb-2",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c("div", {
                                  staticClass:
                                    "bb-badge badge-xs badge-rounded",
                                  class: staffMember.color,
                                }),
                                _c(
                                  "span",
                                  { staticClass: "staff-statistic-name" },
                                  [_vm._v(_vm._s(staffMember.fullName))]
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "staff-statistic-precentage" },
                              [
                                _vm._v(
                                  "(" + _vm._s(staffMember.precentage) + "%)"
                                ),
                              ]
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "bb-card statistic-card",
              staticStyle: { flex: "2" },
            },
            [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("statistics.topServicesCard.title"))),
              ]),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.currentStatistic ||
                        !_vm.currentStatistic.topServices,
                      expression:
                        "!currentStatistic || !currentStatistic.topServices",
                    },
                  ],
                },
                [_vm._v(" " + _vm._s(_vm.$t("statistics.noDataLabel")) + " ")]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center mb-3",
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.currentStatistic &&
                            _vm.currentStatistic.topServices,
                          expression:
                            "\n                        currentStatistic && currentStatistic.topServices\n                    ",
                        },
                      ],
                      staticClass: "statistic-card-label",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("statistics.topServicesCard.serviceNameLabel")
                        )
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.currentStatistic &&
                            _vm.currentStatistic.topServices,
                          expression:
                            "\n                        currentStatistic && currentStatistic.topServices\n                    ",
                        },
                      ],
                      staticClass: "statistic-card-label",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("statistics.topServicesCard.totalSalesLabel")
                        )
                      ),
                    ]
                  ),
                ]
              ),
              _vm._l(
                _vm.currentStatistic.topServices,
                function (service, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "d-flex justify-content-between align-items-center statistic-service-list-item",
                    },
                    [
                      _c("span", [_vm._v(_vm._s(service.serviceName))]),
                      _c("span", [_vm._v(_vm._s(service.totalSales))]),
                    ]
                  )
                }
              ),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "bb-card statistic-card total-sales-chart-card mt-5" },
        [
          _c("h4", [
            _vm._v(
              _vm._s(_vm.$t("statistics.totalSalesLabel")) +
                " (" +
                _vm._s(_vm.$t("statistics.allTimeLabel")) +
                ")"
            ),
          ]),
          _c("div", { staticClass: "bb-line-chart-legend" }, [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("div", {
                staticClass: "bb-badge badge-xs badge-rounded",
                staticStyle: { background: "#5860ab" },
              }),
              _c("span", { staticClass: "bb-line-chart-legend-text" }, [
                _vm._v(_vm._s(_vm.$t("statistics.charts.currentIncomeLabel"))),
              ]),
            ]),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("div", {
                staticClass: "bb-badge badge-xs badge-rounded danger",
              }),
              _c("span", { staticClass: "bb-line-chart-legend-text" }, [
                _vm._v(_vm._s(_vm.$t("statistics.charts.pastYearLabel"))),
              ]),
            ]),
          ]),
          _c("SalesChart", {
            ref: "salesChart",
            staticClass: "sales-chart",
            staticStyle: { "pointer-events": "none" },
            attrs: { chartData: _vm.salesChartData },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "bb-card statistic-card total-appointments-chart-card mt-5",
        },
        [
          _c("h4", [
            _vm._v(
              _vm._s(_vm.$t("statistics.totalAppointmentsLabel")) +
                " (" +
                _vm._s(_vm.$t("statistics.allTimeLabel")) +
                ")"
            ),
          ]),
          _c("div", { staticClass: "bb-line-chart-legend" }, [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("div", {
                staticClass: "bb-badge badge-xs badge-rounded",
                staticStyle: { background: "#5860ab" },
              }),
              _c("span", { staticClass: "bb-line-chart-legend-text" }, [
                _vm._v(
                  _vm._s(_vm.$t("statistics.charts.currentAppointmentsLabel"))
                ),
              ]),
            ]),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("div", {
                staticClass: "bb-badge badge-xs badge-rounded danger",
              }),
              _c("span", { staticClass: "bb-line-chart-legend-text" }, [
                _vm._v(_vm._s(_vm.$t("statistics.charts.pastYearLabel"))),
              ]),
            ]),
          ]),
          _c("AppointmentsChart", {
            ref: "appointmentsChart",
            staticClass: "appointments-chart",
            staticStyle: { "pointer-events": "none" },
            attrs: { chartData: _vm.appointmentsChartData },
          }),
        ],
        1
      ),
      _c("StatisticsMobilePlacesFilter", {
        on: {
          placeChanged: function ($event) {
            return _vm.placeChanged($event)
          },
        },
      }),
      _c("StatisticsMobilePeriodFilter", {
        ref: "mobilePeriodFilter",
        on: {
          periodChanged: function ($event) {
            return _vm.periodChanged($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }